import { render, staticRenderFns } from "./RelatorioCobranca.vue?vue&type=template&id=0e6fbae4&scoped=true&"
import script from "./RelatorioCobranca.vue?vue&type=script&lang=js&"
export * from "./RelatorioCobranca.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioCobranca.vue?vue&type=style&index=0&id=0e6fbae4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6fbae4",
  null
  
)

export default component.exports